// CardProduct.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight, MapPin, PackageCheck } from "lucide-react";
import { formatNombre } from "../lib/utils";

interface CardProps {
  image?: string;
  title: string;
  quality?: string;
  price?: string;
  stock?: any;
  uml?: string;
  quantity?: number;
  seller?: string;
  productId: any;
  sub_category_name: string;
  category_name: string;
}

const ProductCard: React.FC<CardProps> = ({
  image,
  title,
  quality,
  price,
  stock,
  seller,
  productId,
  sub_category_name,
  category_name,
  uml
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleImageClick = () => {
    navigate(`/detail_produit/${productId}`);
  };

  return (
    <div className="group mx-auto flex h-full w-full cursor-pointer flex-col overflow-hidden rounded-2xl border border-gray-100 bg-white font-dm shadow-[0_10px_30px_rgba(15,23,42,0.08)] transition-all duration-300 hover:-translate-y-1 hover:border-primary/20 hover:shadow-[0_18px_40px_rgba(15,23,42,0.14)] md:w-[290px] lg:w-[260px]">
      <div className="relative overflow-hidden bg-[#f3f6f1]">
        <img
          onClick={handleImageClick}
          className=" h-[150px] md:h-[170px] w-full cursor-pointer object-cover transition duration-500 group-hover:scale-105 lg:h-[220px]"
          src={image}
          alt={title}
        />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/45 to-transparent" />
        <div className="absolute bottom-0 left-0 h-1 w-1/3 bg-[#93C01F]" />
        <div className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-white/95 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-gray-700 shadow-sm">
          <span className="h-1.5 w-1.5 rounded-full bg-primary" />
          {sub_category_name}
        </div>
        {stock === 0 && (
          <div className="absolute bottom-3 right-3 rounded-full bg-secondary px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-white shadow-lg">
            {t("rupture_stock")}
          </div>
        )}
        <div className="absolute bottom-3 left-3 flex items-center gap-1 text-[10px] font-medium text-white/90">
          <PackageCheck size={13} strokeWidth={2.2} />
          <span>{stock === 0 ? t("rupture_stock") : t("stock")}</span>
        </div>
      </div>

      <div className="flex flex-col justify-between px-4 pb-2 pt-3 text-gray-700">
        <div className="mb-2 ">
          <div className="mb-2 flex items-start justify-between gap-3">
            <h2 className="line-clamp-2 text-[17px] font-bold leading-tight text-gray-900 transition-colors group-hover:text-primary">{title}</h2>
            <ArrowUpRight className="mt-0.5 shrink-0 text-gray-300 transition-colors group-hover:text-primary" size={18} />
          </div>
          <p className="mb-1 hidden md:flex uppercase  items-center gap-1 text-[11px] text-gray-500">
            <MapPin size={12} className="text-[#E4C003]" />
            <span>{category_name}</span>
          </p>
          {/* {t("commande_minimal")}  */}
          {quality &&(
            <p  className="text-[11px] hidden md:flex line-clamp-1 text-gray-500">
              {t("commande_minimal")} : <span className="font-bold text-secondary">{quality}</span>
            </p>
          )}
          {uml &&(
            <p  className="text-[11px] hidden md:flex line-clamp-1 text-gray-500">
              {t("unite")} : <span className="font-bold text-[#333]">{uml}</span>
            </p>
          )}
        </div>

        {price && <div className="flex items-end justify-between gap-3 border-t border-gray-100 pt-2">
          <div>
            {price ? <p className="text-lg font-extrabold tracking-tight leading-5 text-primary">{formatNombre(Number(price))} <span className="text-[10px] leading-2 font-semibold text-gray-500">FCFA</span></p> : ""}
            {seller && <p className="mt-1 truncate text-[10px] text-gray-400"><i>{t("vendeur")}</i> : <span className="font-medium text-gray-700">{seller}</span></p>}
          </div>
          <span className="h-2 w-2 shrink-0 rounded-full bg-[#93C01F] shadow-[0_0_0_4px_rgba(147,192,31,0.12)]" />
        </div>}
        </div>

        {/* <div>
          {price ? (
            <p className="text-[#15803D] font-bold text-lg mb-1">
              {formatNombre(Number(price))} <span className="text-xs font-semibold">FCFA</span>{uml ? <span className="text-gray-500 text-xs font-normal">/{uml}</span> : ''}
            </p>
          ) : null}

          {seller && (
            <p className="text-xs text-gray-400">
              <span className="italic">{t("vendeur")}</span> : <span className="text-gray-700 font-medium">{seller}</span>
            </p>
          )}
        </div> */}
      {/* </div> */}
    </div>
  );
};

export default ProductCard;
